/* cart-drawer.js — <cart-drawer> custom element + AJAX cart via Shopify Section Rendering API.
   Framework-free, deferred. Falls back to normal /cart navigation if JS fails. */
(function () {
  'use strict';

  function a11y(key, fallback) {
    return window.puString ? window.puString(key, fallback) : fallback;
  }

  var SECTION = 'cart-drawer';
  var atcInflight = new WeakSet();

  function isCartAddAction(action) {
    return /\/cart\/add(?:\.js)?\/?(?:[?#]|$)/.test(action || '');
  }

  function cartAddButtons(form, submitter) {
    var buttons = [];
    function push(btn) {
      if (!btn || btn.nodeType !== 1) return;
      if (btn.type && btn.type !== 'submit') return;
      if (buttons.indexOf(btn) !== -1) return;
      buttons.push(btn);
    }
    push(submitter);
    var inside = form.querySelectorAll('button[type="submit"], input[type="submit"]');
    var i;
    for (i = 0; i < inside.length; i++) push(inside[i]);
    // name="id" on the variant input shadows the form's id property.
    var formId = form.getAttribute('id');
    if (formId) {
      var outside = document.querySelectorAll('[form="' + formId + '"]');
      for (i = 0; i < outside.length; i++) push(outside[i]);
    }
    return buttons;
  }

  function lockAtcButtons(buttons) {
    var locked = [];
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.disabled) continue;
      locked.push(btn);
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    return locked;
  }

  function unlockAtcButtons(locked) {
    for (var i = 0; i < locked.length; i++) {
      var btn = locked[i];
      if (!btn.isConnected) continue;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  function fmtFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function cartProps(line) {
    var props = line && line.properties;
    if (!props) return {};
    if (Array.isArray(props)) {
      var obj = {};
      props.forEach(function (p) {
        if (p && p.name) obj[p.name] = p.value;
      });
      return obj;
    }
    return props;
  }

  function cartCustomAmount(line) {
    var amount = cartProps(line)._gwd_custom_amount;
    if (amount == null || amount === '') return '';
    return String(amount);
  }

  function isCartCustomLine(line, variantId) {
    return cartVariantId(line) === variantId
      && cartCustomAmount(line) !== ''
      && String(cartProps(line)._gwd_source || '') === 'cart';
  }

  function cartVariantId(line) {
    if (!line) return '';
    return String(line.variant_id != null ? line.variant_id : line.id);
  }

  function cartFailed(res) {
    return !!(res && typeof res.status === 'number' && res.status >= 400);
  }

  function publishShopifyAnalytics(eventName, payload) {
    try {
      if (typeof window.puPublishAnalytics === 'function') {
        window.puPublishAnalytics(eventName, payload);
        return;
      }
      if (!(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function')) return;
      window.Shopify.analytics.publish(eventName, payload);
    } catch (err) {}
  }

  /* Mission Other on the Support PragerU donation product.
     Preset cents add that variant at quantity 1 (same as the chips) and
     do not set _gwd_custom_amount.
     Any other amount of at least $1.00, including cents, adds PUDONATE-1
     (data-donation-unit) at quantity 1. _gwd_custom_amount is integer cents
     ("750" is $7.50). _gwd_source is "cart-mission-other" so Cart Transform
     can reprice this line without matching the free-ship source "cart".
     Free-ship Donate still adds gift-with-donation Custom. This path never does. */
  function donationParse(raw) {
    var s = String(raw == null ? '' : raw).replace(/[$,\s]/g, '');
    if (!s) return { kind: 'empty' };
    if (/^\d+\.$/.test(s)) return { kind: 'incomplete' };
    if (!/^\d+(\.\d{1,2})?$/.test(s)) return { kind: 'invalid' };
    var bits = s.split('.');
    var dollars = parseInt(bits[0], 10);
    var frac = bits[1] || '0';
    if (frac.length === 1) frac += '0';
    var cents = dollars * 100 + parseInt(frac, 10);
    if (!Number.isSafeInteger(cents)) return { kind: 'invalid' };
    return { kind: 'number', cents: cents };
  }

  function donationAddLabel(box) {
    var label = box && box.getAttribute('data-donation-add-label');
    if (label == null || label === '') return 'Donate';
    return label;
  }

  function donationFormat(cents) {
    var n = Math.abs(cents);
    var dollars = Math.floor(n / 100);
    var frac = n % 100;
    var text = String(dollars);
    if (frac) text += '.' + (frac < 10 ? '0' : '') + frac;
    return '$' + text;
  }

  function donationVariants(box) {
    try {
      var parsed = JSON.parse(box.getAttribute('data-donation-variants') || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  function donationPlan(box, raw) {
    var parsed = donationParse(raw);
    var floor = parseInt(box.getAttribute('data-donation-floor'), 10);
    if (!isFinite(floor)) floor = 100;
    if (parsed.kind === 'empty') return { ok: false, silent: true };
    if (parsed.kind !== 'number') {
      return { ok: false, error: box.getAttribute('data-donation-format-error') || 'Enter a donation amount in dollars.' };
    }
    var cents = parsed.cents;
    if (cents < floor) {
      return { ok: false, error: box.getAttribute('data-donation-min-error') || 'Enter at least $1.' };
    }
    var variants = donationVariants(box);
    for (var i = 0; i < variants.length; i++) {
      if (parseInt(variants[i].cents, 10) === cents) {
        var presetId = parseInt(variants[i].id, 10);
        if (presetId) return { ok: true, id: presetId, qty: 1, cents: cents, custom: false };
      }
    }
    var dollarId = parseInt(box.getAttribute('data-donation-unit'), 10) || 0;
    if (dollarId) {
      return { ok: true, id: dollarId, qty: 1, cents: cents, custom: true };
    }
    return { ok: false, error: box.getAttribute('data-donation-unavailable-error') || 'That amount is not available.' };
  }

  function fetchSections(ids) {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', ids.join(','));
    return fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) { return { sections: sections }; });
  }

  // Currently-applied removable discount codes rendered in `root`, optionally minus one code.
  function gatherAppliedCodes(root, removeCode) {
    var codes = [];
    if (!root) return codes;
    root.querySelectorAll('[data-discount-remove]').forEach(function (b) {
      var c = b.getAttribute('data-discount-remove');
      if (c) codes.push(c);
    });
    if (removeCode) codes = codes.filter(function (c) { return c.toLowerCase() !== removeCode.toLowerCase(); });
    return codes;
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusFirst(root) {
    if (!root) return false;
    // #CartDrawer is tabindex="-1". Focus the dialog itself so mobile does
    // not land on a text field. The close button is display:none under 1200px.
    if (root.getAttribute('tabindex') === '-1' && root.getClientRects().length) {
      root.focus({ preventScroll: true });
      if (document.activeElement === root) return true;
    }
    var nodes = root.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('[hidden]') || el.getAttribute('aria-hidden') === 'true' || !el.getClientRects().length) continue;
      el.focus({ preventScroll: true });
      if (document.activeElement === el) return true;
    }
    return false;
  }

  // True if `code` ended up applied (via the response's discount_codes, or the re-rendered chips).
  function codeApplied(root, res, code) {
    var lc = code.toLowerCase();
    var byResponse = res && Array.isArray(res.discount_codes) &&
      res.discount_codes.some(function (d) { return d.code && d.code.toLowerCase() === lc && d.applicable; });
    var byDom = gatherAppliedCodes(root).some(function (c) { return c.toLowerCase() === lc; });
    return byResponse || byDom;
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('#CartDrawer');
      this.overlay = this.querySelector('.cart-drawer__overlay');
      this.inner = this.querySelector('[data-cart-drawer-inner]');
      this.toggle = document.querySelector('[data-cart-drawer-toggle]');

      // The head listener (snippets/cart-add-listener.liquid) stops the
      // native submit before Shopify counts it, then calls this handler so
      // there is exactly one /cart/add.js. The document listener below is
      // the fallback for a page that did not get that head script.
      window.__pragerAtc = window.__pragerAtc || {};
      window.__pragerAtc.handler = function (form, submitter) {
        var el = document.querySelector('cart-drawer');
        if (el && typeof el.addFromForm === 'function') el.addFromForm(form, submitter);
      };

      if (this.toggle) this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.classList.contains('is-open')) this.close();
        else this.open({ viewCart: true });
      });
      this.querySelectorAll('[data-cart-drawer-close]').forEach((el) =>
        el.addEventListener('click', () => this.close()));
      // Capture so this runs before quick-view.js removes .is-open. Escape
      // closes only the modal while that modal is open.
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.classList.contains('is-open')) return;
        if (e.target.closest && e.target.closest('.quick-view-modal')) return;
        if (document.querySelector('.quick-view-modal.is-open')) return;
        this.close();
      }, true);
      this.syncInDrawerClose();

      // Quantity steppers / remove / one-tap add (event delegation; survives re-render).
      this.addEventListener('click', (e) => {
        var donateToggle = e.target.closest('[data-cart-donate-toggle]');
        if (donateToggle) {
          e.preventDefault();
          this.toggleMissionDonation(donateToggle);
          return;
        }
        var donateAdd = e.target.closest('[data-cart-donate-add]');
        if (donateAdd) {
          e.preventDefault();
          this.commitMissionDonation(donateAdd);
          return;
        }
        var addBtn = e.target.closest('[data-cart-add]');
        if (addBtn) {
          e.preventDefault();
          if (addBtn.disabled || addBtn.getAttribute('aria-busy') === 'true') return;
          var variantId = addBtn.getAttribute('data-cart-add');
          if (!variantId) return;
          addBtn.disabled = true;
          addBtn.setAttribute('aria-busy', 'true');
          var pendingBtn = addBtn;
          Promise.resolve(this.addVariant(variantId)).then(function () {
            if (!pendingBtn.isConnected) return;
            pendingBtn.disabled = false;
            pendingBtn.removeAttribute('aria-busy');
          });
          return;
        }
        var discRemove = e.target.closest('[data-discount-remove]');
        if (discRemove) {
          e.preventDefault();
          this.setDiscounts(gatherAppliedCodes(this, discRemove.getAttribute('data-discount-remove')));
          return;
        }
        var discApply = e.target.closest('[data-discount-apply]');
        if (discApply) { e.preventDefault(); this.applyEnteredDiscount(); return; }
        var change = e.target.closest('[data-qty-change]');
        var setEl = e.target.closest('[data-qty-set]');
        if (change) {
          var line = change.getAttribute('data-qty-change');
          var delta = parseInt(change.getAttribute('data-qty-delta'), 10);
          var current = parseInt(change.closest('[data-qty]').querySelector('.qty__val').textContent, 10);
          this.changeLine(line, Math.max(0, current + delta));
        } else if (setEl) {
          this.changeLine(setEl.getAttribute('data-qty-set'), parseInt(setEl.getAttribute('data-qty-value'), 10));
        }
      });

      // Enter in the discount field applies the code (no nested <form> to submit).
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-discount-input]')) {
          e.preventDefault();
          this.applyEnteredDiscount();
        }
        // The write-in is not inside CartDrawerForm. Enter donates. It must not check out.
        if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cart-donate-input]')) {
          e.preventDefault();
          this.commitMissionDonation(e.target);
        }
      });

      this.addEventListener('input', (e) => {
        if (e.target.matches && e.target.matches('[data-cart-donate-input]')) {
          var donateBox = e.target.closest('[data-cart-donate-other]');
          if (donateBox) this.syncMissionDonation(donateBox, false);
          return;
        }
        if (!e.target.matches || !e.target.matches('[data-discount-input]')) return;
        e.target.removeAttribute('aria-invalid');
        var msg = this.querySelector('[data-discount-msg]');
        if (msg && !msg.hidden) { msg.hidden = true; msg.textContent = ''; }
      });

      this.addEventListener('focusout', (e) => {
        if (!e.target.matches || !e.target.matches('[data-cart-donate-input]')) return;
        var donateBox = e.target.closest('[data-cart-donate-other]');
        if (donateBox) this.syncMissionDonation(donateBox, true);
      });

      // visualViewport scroll can fire every frame while the URL bar moves.
      // Coalesce to one layout per frame. Chrome inset is a style walk, so
      // keep it cached across those scroll frames and drop it on resize.
      this._scheduleHubLayout = () => {
        if (this._hubFrame) return;
        var hub = document.body.classList.contains('has-cart-drawer');
        var open = this.classList.contains('is-open');
        if (!hub && !open) return;
        this._hubFrame = requestAnimationFrame(() => {
          this._hubFrame = 0;
          if (document.body.classList.contains('has-cart-drawer')) this.shiftHubForDrawer();
          if (!this.classList.contains('is-open')) return;
          var mobile = window.matchMedia('(max-width: 1199px)').matches;
          if (mobile !== !!this._lockedMobile && this._pageLocked) {
            this._chromeInset = null;
            this.unlockPage();
            this.lockPage();
          }
          this.pinSheet();
        });
      };
      this._onHubResize = () => {
        this._chromeInset = null;
        this.syncInDrawerClose();
        this._scheduleHubLayout();
      };
      window.addEventListener('resize', this._onHubResize);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this._onHubResize);
        window.visualViewport.addEventListener('scroll', this._scheduleHubLayout);
      }
      // Keep a scrolled page from moving under the sheet. The cart list is the
      // only region that should scroll while the drawer is open.
      this._onTouchMove = (e) => {
        if (!this.classList.contains('is-open')) return;
        if (e.target.closest && e.target.closest('.quick-view-modal')) return;
        if (this.drawer && this.drawer.contains(e.target)) return;
        if (e.cancelable) e.preventDefault();
      };
      document.addEventListener('touchmove', this._onTouchMove, { passive: false });

      // Fallback when the head listener did not stop the submit (it is not
      // on the page, or cart-drawer.js was not ready yet). addFromForm ignores
      // a second call while the first /cart/add.js is still in flight.
      if (!window.__pragerAtc.fallbackBound) {
        window.__pragerAtc.fallbackBound = true;
        document.addEventListener('submit', (e) => {
          var form = e.target && e.target.nodeName === 'FORM' ? e.target : null;
          if (!form || !isCartAddAction(form.getAttribute('action') || form.action || '')) return;
          e.preventDefault();
          var el = document.querySelector('cart-drawer');
          if (el && typeof el.addFromForm === 'function') el.addFromForm(form, e.submitter || null);
        });
      }

      // Gift-with-donation: a button carrying a JSON list of items. The product-page
      // box sends the donation and the gift together, with a shared _gwd_pair.
      // data-cart-donate-commit is the free-ship bar (source "cart") and does not
      // include a product gift.
      document.addEventListener('click', (e) => {
        var g = e.target.closest('[data-gift-donate]');
        if (!g) return;
        e.preventDefault();
        var items;
        try { items = JSON.parse(g.getAttribute('data-gift-donate')); } catch (err) { return; }
        if (Array.isArray(items) && items.length) {
          if (g.hasAttribute('data-cart-donate-commit')) this.commitCartDonation(items, g);
          else this.addItems(items);
        }
      });
    }

    /* Header icon passes viewCart with no trigger, so that open publishes
       cart:drawer-opened and cart_drawer_viewed exactly as before.
       Add-to-cart calls open() without viewCart, so it does not publish.
       Auto-open passes viewCart plus trigger cart_redirect or
       checkout_return, and the same publish runs once. close() clears the
       flag, so each later user open publishes once. */
    announceCartView(trigger) {
      if (this._cartViewAnnounced) return;
      this._cartViewAnnounced = true;
      var payload = { currency: '', value: 0, items: [] };
      var node = this.querySelector('[data-cart-analytics]');
      if (node && node.textContent) {
        try {
          var raw = JSON.parse(node.textContent);
          var dollars = function (cents) {
            var n = parseInt(cents, 10);
            return isFinite(n) ? n / 100 : 0;
          };
          payload.currency = raw.currency || '';
          payload.value = dollars(raw.value_cents);
          var list = Array.isArray(raw.items) ? raw.items : [];
          payload.items = list.map(function (item) {
            var variant = item.item_variant || '';
            if (variant === 'Default Title') variant = '';
            return {
              item_id: item.item_id == null ? '' : String(item.item_id),
              item_name: item.item_name || '',
              item_variant: variant,
              price: dollars(item.price_cents),
              quantity: parseInt(item.quantity, 10) || 0
            };
          });
        } catch (err) {}
      }
      if (trigger) payload.trigger = trigger;
      window.dispatchEvent(new CustomEvent('cart:drawer-opened', { detail: payload }));
      publishShopifyAnalytics('cart_drawer_viewed', { cart: payload });
    }

    open(opts) {
      if (opts && opts.viewCart) this.announceCartView(opts.trigger);
      // The menu marks this drawer inert. Close it first so this sheet can take focus.
      var menu = document.querySelector('menu-drawer.is-open');
      if (menu && typeof menu.close === 'function') menu.close({ restoreFocus: false });
      // Cancel a close that has not finished hiding the sheet.
      this._closeToken = (this._closeToken || 0) + 1;
      // Measure bottom chrome once per open. Scroll frames reuse the cache.
      this._chromeInset = null;
      // Stop the page from scrolling under the sheet, pin the header, then
      // size the mobile sheet to the visible viewport above bottom chrome.
      this.lockPage();
      this.drawer.hidden = false;
      this.overlay.hidden = false;
      this.pinSheet();
      this.resetSheetScroll();
      if (this._openFrame) cancelAnimationFrame(this._openFrame);
      // Next frame so the sheet is visibility:visible (mobile hides it until
      // is-open). Focusing earlier is a no-op, and the close button is not rendered.
      this._openFrame = requestAnimationFrame(() => {
        this._openFrame = 0;
        if (this.drawer && this.drawer.hidden) return;
        this.classList.add('is-open');
        this.pinSheet();
        this.resetSheetScroll();
        this.syncCartOpenFlag();
        syncCartRecArrows(this);
        // Mobile keeps visibility:hidden through the start of the open
        // transition, past a single next frame. Keep trying until the sheet
        // can take focus. Closing the menu without moving focus is not enough
        // on its own: the first frames cannot hold document focus.
        var tries = 0;
        var focusSheet = () => {
          this._openFrame = 0;
          if (!this.classList.contains('is-open') || !this.drawer || this.drawer.hidden) return;
          if (focusFirst(this.drawer)) return;
          if (tries++ >= 12) return;
          this._openFrame = requestAnimationFrame(focusSheet);
        };
        focusSheet();
      });
      this.raiseHubLauncher();
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'true');
        this.toggle.setAttribute('aria-label', this.getAttribute('data-label-close') || a11y('closeCart', 'Close cart'));
      }
    }

    lockPage() {
      if (this._scrollRestore) {
        cancelAnimationFrame(this._scrollRestore);
        this._scrollRestore = 0;
      }
      if (this._pageLocked) return;
      var mobile = window.matchMedia('(max-width: 1199px)').matches;
      this._lockedMobile = mobile;
      this._pageLocked = true;
      if (mobile) {
        // Capture scroll before the body lock. overflow:hidden alone unsticks
        // the header, so a mid-page open left a gap of page content above the
        // sheet while the sheet still indented by the header height.
        this._scrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.body.style.top = (-this._scrollY) + 'px';
        document.body.style.position = 'fixed';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        this.pinHeader();
      }
      document.documentElement.classList.add('cart-drawer-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    // Quick view close writes body overflow back to empty. Put this sheet's
    // lock back when the drawer is still open, including the mobile
    // position and top pin lockPage stored.
    reassertPageLock() {
      if (!this._pageLocked || !this.classList.contains('is-open')) return;
      document.documentElement.classList.add('cart-drawer-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (!this._lockedMobile) return;
      var y = this._scrollY || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-y) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      this.pinHeader();
    }

    unlockPage() {
      if (!this._pageLocked) return;
      var mobile = !!this._lockedMobile;
      var y = this._scrollY || 0;
      // Body overflow is shared. A cart close (and the pageshow recovery
      // that calls this) must not drop a lock Quick View, the menu, search,
      // or the filter drawer still holds. otherOverlayHoldsScrollLock is
      // the same open-state check releaseHubIfDrawerClosed uses.
      var keepScrollLock = otherOverlayHoldsScrollLock();
      this._pageLocked = false;
      this._lockedMobile = false;
      this._scrollY = 0;
      document.documentElement.classList.remove('cart-drawer-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = keepScrollLock ? 'hidden' : '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      this.releaseHeader();
      if (mobile) {
        // html { scroll-behavior: smooth } makes scrollTo animate from 0.
        // The first frames after the fixed body is released are the hero,
        // and a cancelled animation never leaves the top. Write the offset
        // with scroll-behavior auto, then once more before the next paint.
        var restore = function () {
          var root = document.documentElement;
          var prevRoot = root.style.scrollBehavior;
          var prevBody = document.body.style.scrollBehavior;
          root.style.scrollBehavior = 'auto';
          document.body.style.scrollBehavior = 'auto';
          if (document.scrollingElement) document.scrollingElement.scrollTop = y;
          root.scrollTop = y;
          window.scrollTo(0, y);
          root.style.scrollBehavior = prevRoot;
          document.body.style.scrollBehavior = prevBody;
        };
        restore();
        this._scrollRestore = requestAnimationFrame(restore);
      }
    }

    // Keep the sticky header on screen while the body is position:fixed.
    // A fixed body does not contain fixed descendants, so the header stays
    // at the visual top instead of riding the saved scroll offset off screen.
    pinHeader() {
      var header = document.querySelector('.site-header');
      if (!header) return;
      header.style.position = 'fixed';
      header.style.top = '0';
      header.style.left = '0';
      header.style.right = '0';
      header.style.width = '100%';
    }

    releaseHeader() {
      var header = document.querySelector('.site-header');
      if (!header) return;
      header.style.position = '';
      header.style.top = '';
      header.style.left = '';
      header.style.right = '';
      header.style.width = '';
    }

    // Mobile sheet fills the visible viewport under the on-screen header and
    // above bottom chrome (Shopify preview bar, horizontal scrollbar).
    // visualViewport covers the URL-bar case where the layout viewport is
    // taller than the screen. Do not fall back to header.offsetHeight when
    // the header is off screen: that indents the sheet and shows the page.
    pinSheet() {
      var drawer = this.drawer;
      if (!drawer) return;
      var mobile = window.matchMedia('(max-width: 1199px)').matches;
      if (!mobile) {
        this.releaseSheetPin();
        return;
      }
      var vv = window.visualViewport;
      var offsetTop = vv ? vv.offsetTop : 0;
      var offsetLeft = vv ? vv.offsetLeft : 0;
      var viewH = vv ? vv.height : window.innerHeight;
      var viewW = vv ? vv.width : window.innerWidth;
      var header = document.querySelector('.site-header');
      var headerBottom = 0;
      if (header) {
        var rect = header.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top <= 1) headerBottom = rect.bottom;
      }
      var chrome = this.bottomChromeInset(viewH);
      var top = Math.round(offsetTop + Math.max(0, headerBottom));
      var height = Math.max(0, Math.round(viewH - Math.max(0, headerBottom) - chrome));
      drawer.style.setProperty('--header-h', Math.round(Math.max(0, headerBottom)) + 'px');
      drawer.style.setProperty('--cart-bottom-inset', Math.round(chrome) + 'px');
      drawer.style.top = top + 'px';
      drawer.style.bottom = 'auto';
      drawer.style.left = Math.round(offsetLeft) + 'px';
      drawer.style.right = 'auto';
      drawer.style.width = Math.round(viewW) + 'px';
      drawer.style.height = height + 'px';
    }

    // Fixed bars painted over the bottom of the layout viewport (theme
    // preview bar). The home indicator is handled by footer padding, not
    // by shortening the sheet a second time.
    bottomChromeInset(viewH) {
      var key = Math.round(viewH);
      if (this._chromeInset != null && this._chromeInsetKey === key) return this._chromeInset;
      var inset = 0;
      var width = window.innerWidth || 1;
      var nodes = [];
      if (document.body) {
        for (var c = 0; c < document.body.children.length; c++) nodes.push(document.body.children[c]);
      }
      document.querySelectorAll('#PBarNextFrame, #preview-bar-iframe, #PBarNextFrameWrapper').forEach(function (el) {
        nodes.push(el);
      });
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!el || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
        if (el.tagName === 'CART-DRAWER' || (el.closest && el.closest('cart-drawer'))) continue;
        if (el.classList && el.classList.contains('site-header')) continue;
        /* The sticky buy bar is fixed to the bottom on purpose. Counting it
           as preview chrome shortens the mobile sheet and leaves that bar
           painted over Checkout. The sheet hides the bar while it is open. */
        if (el.hasAttribute && el.hasAttribute('data-sticky-atc')) continue;
        if (el.classList && el.classList.contains('sticky-atc')) continue;
        var cs;
        try { cs = window.getComputedStyle(el); } catch (err) { continue; }
        if (!cs || (cs.position !== 'fixed' && cs.position !== 'sticky')) continue;
        if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;
        var r = el.getBoundingClientRect();
        if (r.height < 24 || r.height > viewH * 0.45) continue;
        if (r.width < width * 0.6) continue;
        var cover = viewH - r.top;
        if (cover > 16 && r.bottom >= viewH - 2 && r.top > viewH * 0.45) {
          inset = Math.max(inset, cover);
        }
      }
      var doc = document.documentElement;
      if (doc && doc.scrollWidth > doc.clientWidth + 2) {
        var bar = Math.round(window.innerHeight - doc.clientHeight);
        if (bar > 1 && bar < 28) inset += bar;
      }
      this._chromeInsetKey = key;
      this._chromeInset = Math.round(inset);
      return this._chromeInset;
    }

    releaseSheetPin() {
      if (!this.drawer) return;
      this.drawer.style.top = '';
      this.drawer.style.height = '';
      this.drawer.style.bottom = '';
      this.drawer.style.left = '';
      this.drawer.style.right = '';
      this.drawer.style.width = '';
      this.drawer.style.removeProperty('--cart-bottom-inset');
    }

    resetSheetScroll() {
      var scroller = this.drawer && this.drawer.querySelector('.cart-drawer__scroll');
      if (scroller) scroller.scrollTop = 0;
    }

    syncCartOpenFlag() {
      var open = this.classList.contains('is-open');
      if (open) document.documentElement.setAttribute('data-cart-open', 'true');
      else document.documentElement.removeAttribute('data-cart-open');
    }

    raiseHubLauncher() {
      // Desktop: measured width → --cart-drawer-offset (CSS shifts right).
      // Mobile hide follows cart-drawer.is-open via data-cart-open, not this
      // body class. Does not write --sticky-atc-height.
      document.body.classList.add('has-cart-drawer');
      this.syncCartOpenFlag();
      this.shiftHubForDrawer();
      requestAnimationFrame(() => {
        if (document.body.classList.contains('has-cart-drawer')) this.shiftHubForDrawer();
      });
    }

    shiftHubForDrawer() {
      var drawer = this.drawer;
      if (!drawer) return;
      this.clearHubInlineOffset();
      // ≤1199 the sheet is full-bleed. CSS hides the launcher; a right offset
      // would fight that hide on rotate. Desktop uses the measured panel.
      if (window.matchMedia('(max-width: 1199px)').matches) {
        document.documentElement.style.setProperty('--cart-drawer-offset', '0px');
        return;
      }
      var width = drawer.offsetWidth || Math.round(drawer.getBoundingClientRect().width);
      if (width < 1) width = 420;
      document.documentElement.style.setProperty('--cart-drawer-offset', Math.round(width) + 'px');
    }

    clearHubInlineOffset() {
      var container = document.querySelector('.kl-hub-launcher-container');
      if (container) {
        container.style.removeProperty('right');
        container.style.removeProperty('bottom');
      }
      var launcher = document.querySelector('.kl-hub-launcher');
      if (launcher) launcher.style.removeProperty('right');
      var panel = document.querySelector('.kl-hub-drawer');
      if (panel) panel.style.removeProperty('right');
    }

    restoreHubLauncher() {
      document.body.classList.remove('has-cart-drawer');
      document.documentElement.removeAttribute('data-cart-open');
      document.documentElement.style.setProperty('--cart-drawer-offset', '0px');
      this.clearHubInlineOffset();
    }

    // Under 1200px the head is display:none and the header cart icon is the
    // close control. This in-drawer button has a 0 box, so keep it out of
    // the tree and the tab order. Desktop leaves it as a normal button.
    syncInDrawerClose() {
      var btn = this.querySelector('.cart-drawer__close');
      if (!btn) return;
      if (window.matchMedia('(max-width: 1199px)').matches) {
        btn.setAttribute('aria-hidden', 'true');
        btn.setAttribute('tabindex', '-1');
      } else {
        btn.removeAttribute('aria-hidden');
        btn.removeAttribute('tabindex');
      }
    }

    close() {
      this._cartViewAnnounced = false;
      if (this._openFrame) {
        cancelAnimationFrame(this._openFrame);
        this._openFrame = 0;
      }
      // Return focus only when it is still inside the sheet (or lost).
      // A click that already moved focus, such as opening another control, keeps it.
      var cartFocus = document.activeElement;
      if (this.toggle && (!cartFocus || cartFocus === document.body || this.drawer.contains(cartFocus))) {
        this.toggle.focus({ preventScroll: true });
      }
      try {
        this.classList.remove('is-open');
        if (this.toggle) {
          this.toggle.setAttribute('aria-expanded', 'false');
          this.toggle.setAttribute('aria-label', this.getAttribute('data-label-cart') || a11y('cart', 'Cart'));
        }
      } finally {
        this.restoreHubLauncher();
      }
      this._closeToken = (this._closeToken || 0) + 1;
      var token = this._closeToken;
      var finish = () => {
        if (token !== this._closeToken) return;
        if (this.classList.contains('is-open')) return;
        this._closeToken = (this._closeToken || 0) + 1;
        this.drawer.hidden = true;
        this.overlay.hidden = true;
        this.releaseSheetPin();
        this.unlockPage();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }
      var onEnd = (e) => {
        if (e.target !== this.drawer) return;
        this.drawer.removeEventListener('transitionend', onEnd);
        finish();
      };
      this.drawer.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, 450);
    }

    addFromForm(form, submitter) {
      if (!form || atcInflight.has(form)) return;
      atcInflight.add(form);
      var locked = lockAtcButtons(cartAddButtons(form, submitter));
      if (form.getAttribute('id') === 'QuickViewForm') {
        document.dispatchEvent(new CustomEvent('cart:add-form', { detail: { form: form } }));
      }
      var data = new FormData(form);
      var body = {};
      data.forEach((v, k) => { body[k] = v; });
      body.sections = [SECTION];
      body.sections_url = window.location.pathname;
      var release = () => {
        atcInflight.delete(form);
        unlockAtcButtons(locked);
      };
      fmtFetch('/cart/add.js', body)
        .then((res) => { if (res && res.sections) this.refresh(res.sections[SECTION]); this.open(); }, () => { HTMLFormElement.prototype.submit.call(form); })
        .catch(() => { window.location.href = '/cart'; })
        .finally(release);
    }

    applyEnteredDiscount() {
      var input = this.querySelector('[data-discount-input]');
      if (!input) return;
      var code = input.value.trim();
      if (!code) return;
      var codes = gatherAppliedCodes(this);
      if (codes.map((c) => c.toLowerCase()).indexOf(code.toLowerCase()) === -1) codes.push(code);
      this.setDiscounts(codes, code);
    }

    setDiscountPending(pending) {
      this._discountPending = pending;
      this.querySelectorAll('[data-discount-remove]').forEach(function (btn) {
        if (pending) {
          btn.setAttribute('aria-busy', 'true');
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('aria-disabled');
        }
      });
    }

    setDiscounts(codes, enteredCode) {
      if (this._discountPending) return;
      this.setDiscountPending(true);
      // Replacing the code list. An empty string clears every code.
      fmtFetch('/cart/update.js', {
        discount: codes.length ? codes.join(',') : '',
        sections: [SECTION],
        sections_url: window.location.pathname,
      })
        .then((res) => {
          if (res && res.sections) this.refresh(res.sections[SECTION], { collapseDiscount: !!enteredCode });
          if (enteredCode && !codeApplied(this, res, enteredCode)) {
            this.showDiscountError(enteredCode);
            return;
          }
          if (!enteredCode) {
            var summary = this.querySelector('.cart-discount__summary');
            if (summary) summary.focus({ preventScroll: true });
            else if (this.drawer) this.drawer.focus({ preventScroll: true });
          }
        })
        .catch(() => { window.location.href = '/cart'; })
        .finally(() => { this.setDiscountPending(false); });
    }

    showDiscountError(code) {
      var panel = this.querySelector('[data-cart-discount]');
      if (panel) panel.open = true;
      var msg = this.querySelector('[data-discount-msg]');
      var text = panel && panel.getAttribute('data-discount-error');
      if (msg && text) {
        msg.hidden = false;
        msg.textContent = text;
      }
      var input = this.querySelector('[data-discount-input]');
      if (input) {
        input.value = code;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
    }

    addItems(items) {
      return fmtFetch('/cart/add.js', {
        items: items,
        sections: [SECTION],
        sections_url: window.location.pathname,
      })
        .then((res) => { if (res && res.sections) this.refresh(res.sections[SECTION]); this.open(); })
        .catch(() => { window.location.href = '/cart'; });
    }

    clearMissionDonationError(box) {
      var el = box.querySelector('[data-cart-donate-error]');
      var input = box.querySelector('[data-cart-donate-input]');
      if (el) {
        el.hidden = true;
        el.textContent = '';
      }
      if (input) input.removeAttribute('aria-invalid');
    }

    showMissionDonationError(box, message) {
      var el = box.querySelector('[data-cart-donate-error]');
      var input = box.querySelector('[data-cart-donate-input]');
      if (el) {
        el.hidden = false;
        el.textContent = message;
      }
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    syncMissionDonation(box, report) {
      var input = box.querySelector('[data-cart-donate-input]');
      var add = box.querySelector('[data-cart-donate-add]');
      var plan = donationPlan(box, input ? input.value : '');
      if (!add) return plan.ok ? plan : null;
      if (plan.ok) {
        this.clearMissionDonationError(box);
        add.disabled = false;
        add.textContent = donationAddLabel(box) + ' ' + donationFormat(plan.cents);
        return plan;
      }
      add.disabled = true;
      add.textContent = donationAddLabel(box);
      if (report && plan.error) this.showMissionDonationError(box, plan.error);
      else this.clearMissionDonationError(box);
      return null;
    }

    toggleMissionDonation(toggle) {
      var box = toggle.closest('[data-cart-donate-other]');
      if (!box) return;
      var form = box.querySelector('[data-cart-donate-form]');
      if (!form) return;
      var willOpen = form.hidden;
      form.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        var input = box.querySelector('[data-cart-donate-input]');
        if (input) input.focus();
        if (form.scrollIntoView) form.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      } else {
        this.clearMissionDonationError(box);
      }
    }

    /* Adds a Support PragerU line at quantity 1.
       Presets have no line properties. Other amounts set _gwd_custom_amount
       to integer cents on PUDONATE-1 so Cart Transform can reprice the line. */
    commitMissionDonation(source) {
      var box = source && source.closest ? source.closest('[data-cart-donate-other]') : null;
      if (!box || this._donatePending) return;
      var plan = this.syncMissionDonation(box, true);
      if (!plan) return;
      this._donatePending = true;
      var btn = box.querySelector('[data-cart-donate-add]');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      var self = this;
      var item = { id: plan.id, quantity: 1 };
      if (plan.custom) {
        item.properties = {
          _gwd_custom_amount: String(plan.cents),
          _gwd_source: 'cart-mission-other'
        };
      }
      this.addItems([item])
        .finally(function () {
          self._donatePending = false;
          if (!box.isConnected) return;
          if (btn && btn.isConnected) btn.removeAttribute('aria-busy');
          self.syncMissionDonation(box, false);
        });
    }

    sectionIds() {
      return [SECTION];
    }

    applyCartSections(res) {
      if (res && res.sections && res.sections[SECTION]) this.refresh(res.sections[SECTION]);
    }

    /* Free-ship Donate: one cart-bar Custom line, quantity 1.
       _gwd_custom_amount is cents. _gwd_source is "cart".
       This is free shipping only. It does not add a product and it does not
       write a pair. Only lines with that source are replaced. A product-page
       Custom line (source "pdp", beside its gift) stays.
       Removals go out in one /cart/update.js call before any add, so a
       failed add cannot leave two cart-bar Custom lines. */
    commitCartDonation(items, trigger) {
      var item = items && items[0];
      var cents = item && item.properties && item.properties._gwd_custom_amount;
      if (!item || cents == null || cents === '') {
        this.addItems(items);
        return;
      }
      if (this._donatePending) return;
      this._donatePending = true;
      var busyBtns = [];
      function trackBusy(btn) {
        if (!btn || !btn.isConnected || busyBtns.some(function (entry) { return entry.el === btn; })) return;
        busyBtns.push({ el: btn, disabled: btn.disabled });
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      trackBusy(this.querySelector('[data-cart-donate] [data-gwd-other-add]'));
      if (trigger && trigger.hasAttribute('data-cart-ship-add')) trackBusy(trigger);
      var self = this;
      var variantId = String(item.id);
      var amount = String(cents);
      function checked(res) {
        if (cartFailed(res)) throw new Error(res.description || res.message || 'cart');
        return res;
      }
      function withSections(body) {
        body.sections = self.sectionIds();
        body.sections_url = window.location.pathname;
        return body;
      }
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lines = (cart.items || []).filter(function (line) {
            return isCartCustomLine(line, variantId);
          });
          var keeper = null;
          for (var i = 0; i < lines.length; i++) {
            if (cartCustomAmount(lines[i]) === amount) { keeper = lines[i]; break; }
          }
          var updates = {};
          lines.forEach(function (line) {
            if (!keeper || line.key !== keeper.key) updates[line.key] = 0;
          });
          if (keeper && keeper.quantity !== 1) updates[keeper.key] = 1;
          var needAdd = !keeper;
          var updateKeys = Object.keys(updates);
          var chain = Promise.resolve(null);
          if (updateKeys.length) {
            chain = fmtFetch('/cart/update.js', needAdd ? { updates: updates } : withSections({ updates: updates })).then(checked);
          }
          if (needAdd) {
            chain = chain.then(function () {
              return fmtFetch('/cart/add.js', withSections({
                items: [{
                  id: item.id,
                  quantity: 1,
                  properties: { _gwd_custom_amount: amount, _gwd_source: 'cart' }
                }]
              })).then(checked);
            });
          }
          return chain.then(function (res) {
            if (res && res.sections) return res;
            return fetchSections(self.sectionIds());
          });
        })
        .then(function (res) {
          self.applyCartSections(res);
          self.open();
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () {
          self._donatePending = false;
          busyBtns.forEach(function (entry) {
            if (!entry.el.isConnected) return;
            entry.el.disabled = entry.disabled;
            entry.el.removeAttribute('aria-busy');
          });
        });
    }

    addVariant(id) { return this.addItems([{ id: parseInt(id, 10), quantity: 1 }]); }

    changeLine(line, quantity) {
      fmtFetch('/cart/change.js', {
        line: parseInt(line, 10),
        quantity: quantity,
        sections: [SECTION],
        sections_url: window.location.pathname,
      })
        .then((res) => { if (res && res.sections) this.refresh(res.sections[SECTION]); })
        .catch(() => { window.location.href = '/cart'; });
    }

    refresh(html, opts) {
      if (!html) return;
      opts = opts || {};
      var prev = this.querySelector('[data-cart-discount]');
      var wasOpen = !!(prev && prev.open);
      var typed = '';
      var prevInput = prev && prev.querySelector('[data-discount-input]');
      if (prevInput) typed = prevInput.value;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      if (fresh && this.inner) {
        this.inner.replaceWith(fresh);
        this.inner = fresh;
        this.updateCount(fresh.getAttribute('data-item-count'));
        if (!opts.collapseDiscount && wasOpen) {
          var next = this.querySelector('[data-cart-discount]');
          if (next) {
            next.open = true;
            var nextInput = next.querySelector('[data-discount-input]');
            if (nextInput && typed) nextInput.value = typed;
          }
        }
      }
    }

    updateCount(count) {
      var n = parseInt(count, 10) || 0;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = n;
        el.classList.toggle('is-empty', n === 0);
      });
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  // /cart stores a timestamp in openCartDrawer, then leaves for a storefront
  // URL that includes cart=open. Skip the cart document itself so this page
  // does not consume the stamp before the redirect lands. On the next page,
  // open once when the navigation type is navigate, this page is not /cart,
  // and the drawer already has items. cart=open and the stamp publish
  // cart_drawer_viewed with trigger cart_redirect. A same-origin checkout
  // referrer (logo or return to store) publishes trigger checkout_return,
  // except thank-you and processing. Reload and back/forward do not open.
  // An activated prerender can also report navigate. An empty cart stays
  // closed. cart=open is removed with replaceState either way. A storage
  // failure falls through to the URL flag and the referrer check.
  var openedCartFromLoad = false;
  var CHECKOUT_REFERRER_RE = /^(?:\/\d+)?(?:\/[a-z]{2}(?:-[a-z0-9]{2,8})?)?\/checkouts?(?:\/|$)/i;

  function drawerItemCount(el) {
    if (!el) return 0;
    var inner = el.querySelector('[data-cart-drawer-inner]');
    if (inner && inner.hasAttribute('data-item-count')) {
      var fromAttr = parseInt(inner.getAttribute('data-item-count'), 10);
      return isNaN(fromAttr) ? 0 : fromAttr;
    }
    var badge = el.querySelector('[data-cart-count]');
    if (!badge) return 0;
    var fromText = parseInt(badge.textContent, 10);
    return isNaN(fromText) ? 0 : fromText;
  }

  function isCartPage() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    var path = window.location.pathname || '/';
    var parts = path.split('/');
    var rest = path;
    if (parts.length > 2 && /^[a-z]{2}(?:-[a-z0-9]{2,8})?$/i.test(parts[1])) {
      rest = '/' + parts.slice(2).join('/');
    }
    if (rest.length > 1 && rest.charAt(rest.length - 1) === '/') rest = rest.slice(0, -1);
    return rest === '/cart' || rest.indexOf('/cart/') === 0;
  }

  function navigationType() {
    try {
      var entries = (window.performance && typeof performance.getEntriesByType === 'function')
        ? performance.getEntriesByType('navigation')
        : null;
      var nav = entries && entries[0];
      return nav && nav.type ? nav.type : '';
    } catch (e) { return ''; }
  }

  function isFreshNavigate() {
    return navigationType() === 'navigate';
  }

  // Thank-you and processing are not a return to the store.
  function isThankYouOrProcessing(path) {
    var value = path || '';
    return /(?:^|\/)thank[-_]you(?:\/|$)/i.test(value) || /(?:^|\/)processing(?:\/|$)/i.test(value);
  }

  function referrerIsCheckoutReturn() {
    if (!document.referrer) return false;
    var url;
    try { url = new URL(document.referrer); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false;
    if (isThankYouOrProcessing(url.pathname)) return false;
    return CHECKOUT_REFERRER_RE.test(url.pathname);
  }

  function hasCartOpenParam() {
    try {
      var values = new URLSearchParams(window.location.search || '').getAll('cart');
      for (var i = 0; i < values.length; i++) if (values[i] === 'open') return true;
    } catch (e) {}
    return false;
  }

  function stripCartOpenParam() {
    try {
      if (!hasCartOpenParam()) return;
      var url = new URL(window.location.href);
      var kept = [];
      url.searchParams.forEach(function (value, key) {
        if (key === 'cart' && value === 'open') return;
        kept.push([key, value]);
      });
      var next = new URLSearchParams();
      for (var i = 0; i < kept.length; i++) next.append(kept[i][0], kept[i][1]);
      var search = next.toString();
      var nextUrl = url.pathname + (search ? '?' + search : '') + url.hash;
      history.replaceState(history.state, '', nextUrl);
    } catch (e) {}
  }

  function openDrawerFromLoad(trigger) {
    if (openedCartFromLoad) return;
    var el = document.querySelector('cart-drawer');
    if (!(el && typeof el.open === 'function')) return;
    openedCartFromLoad = true;
    el.open({ viewCart: true, trigger: trigger });
  }

  function openCartFromRedirect() {
    if (openedCartFromLoad) return;
    if (document.documentElement.classList.contains('cart-redirecting')) return;
    if (isCartPage()) {
      stripCartOpenParam();
      return;
    }
    var raw = '';
    var storageOk = true;
    try { raw = sessionStorage.getItem('openCartDrawer') || ''; } catch (e) { storageOk = false; }
    var stampFresh = false;
    if (storageOk) {
      var ts = parseInt(raw, 10);
      if (ts) {
        try { sessionStorage.removeItem('openCartDrawer'); } catch (e) {}
        if (Date.now() - ts <= 60000) stampFresh = true;
      }
    }
    var cartOpen = hasCartOpenParam();
    var fresh = isFreshNavigate();
    var hasItems = drawerItemCount(document.querySelector('cart-drawer')) >= 1;
    var fromCheckout = referrerIsCheckoutReturn();
    if (fresh && hasItems && (stampFresh || cartOpen || fromCheckout)) {
      openDrawerFromLoad(cartOpen || !fromCheckout ? 'cart_redirect' : 'checkout_return');
    }
    if (cartOpen) stripCartOpenParam();
  }
  if (document.readyState !== 'loading') openCartFromRedirect();
  else document.addEventListener('DOMContentLoaded', openCartFromRedirect);

  // Shopify only fills `recommendations` when the section is rendered from
  // /recommendations/products. Complementary is the cart intent. Related is
  // used only when complementary leaves no in-band cards. The $15 to $35
  // band stays. If that still leaves fewer than 3 cards, top up from the
  // hidden upsell collection list. Never pad with out-of-band products.
  var REC_BAND_MIN = 1500;
  var REC_BAND_MAX = 3500;
  var REC_CAP = 3;

  function fetchRecs(base, productId, intent) {
    var url = base + '?section_id=cart-recommendations&product_id=' + encodeURIComponent(productId) + '&limit=10&intent=' + intent;
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { return recsPayload(html, intent); })
      .catch(function () { return { count: 0, html: '', intent: intent }; });
  }

  function recsPayload(html, intent) {
    var empty = { count: 0, html: '', intent: intent };
    if (!html) return empty;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var list = doc.querySelector('[data-cart-recs-results]');
    if (!list) return empty;
    // .cart-rec is the slide around snippets/product-card. The data-rec-*
    // attributes live on that slide, not on the card.
    var cards = list.querySelectorAll('.cart-rec');
    if (!cards.length) return empty;
    return { count: cards.length, html: list.innerHTML, intent: intent };
  }

  function recInBand(card) {
    var cents = parseInt(card.getAttribute('data-rec-price'), 10);
    return !isNaN(cents) && cents >= REC_BAND_MIN && cents <= REC_BAND_MAX;
  }

  function recKey(card) {
    var handle = card.getAttribute('data-rec-handle');
    if (handle) return handle;
    var title = card.querySelector('.product-card__title');
    var href = title && title.getAttribute('href');
    if (!href) return '';
    return String(href).split('?')[0];
  }

  function trimRecTrack(track) {
    var kept = 0;
    var cards = track.querySelectorAll('.cart-rec');
    for (var i = 0; i < cards.length; i++) {
      if (kept >= REC_CAP || !recInBand(cards[i])) cards[i].remove();
      else kept += 1;
    }
    return kept;
  }

  function fillRecTrack(track, fallback) {
    var kept = trimRecTrack(track);
    if (kept >= REC_CAP || !fallback) return kept;
    var seen = {};
    var current = track.querySelectorAll('.cart-rec');
    for (var i = 0; i < current.length; i++) {
      var key = recKey(current[i]);
      if (key) seen[key] = true;
    }
    var extras = fallback.querySelectorAll('.cart-rec');
    for (var j = 0; j < extras.length && kept < REC_CAP; j++) {
      if (!recInBand(extras[j])) continue;
      var extraKey = recKey(extras[j]);
      if (extraKey && seen[extraKey]) continue;
      if (extraKey) seen[extraKey] = true;
      track.appendChild(extras[j].cloneNode(true));
      kept += 1;
    }
    return kept;
  }

  // Winning in-band payload before the collection top-up. The key is the
  // seed plus the sorted cart product ids, so adding a recommended product
  // cannot replay that product from a previous cart. Related is requested
  // only when complementary keeps zero in-band cards.
  var recCache = Object.create(null);
  var recInflight = Object.create(null);

  function recCacheKey(productId, sig) {
    return String(productId) + '|' + (sig || '');
  }

  function dropInCartCards(track, sig) {
    if (!track || !sig) return;
    var inCart = Object.create(null);
    String(sig).split(',').forEach(function (id) {
      if (id) inCart[id] = true;
    });
    var cards = track.querySelectorAll('.cart-rec');
    for (var i = 0; i < cards.length; i++) {
      var id = cards[i].getAttribute('data-rec-id');
      if (id && inCart[id]) cards[i].remove();
    }
  }

  function loadRecApi(base, productId, cacheKey) {
    if (recCache[cacheKey]) return Promise.resolve(recCache[cacheKey]);
    if (recInflight[cacheKey]) return recInflight[cacheKey];
    var job = fetchRecs(base, productId, 'complementary').then(function (comp) {
      var probe = document.createElement('ul');
      if (comp.html) {
        probe.innerHTML = comp.html;
        if (trimRecTrack(probe) > 0) {
          return { html: probe.innerHTML, intent: comp.intent || 'complementary' };
        }
      }
      return fetchRecs(base, productId, 'related').then(function (rel) {
        probe = document.createElement('ul');
        if (rel.html) {
          probe.innerHTML = rel.html;
          if (trimRecTrack(probe) > 0) {
            return { html: probe.innerHTML, intent: rel.intent || 'related' };
          }
        }
        return { html: '', intent: '' };
      });
    }).then(function (api) {
      if (api && api.html) recCache[cacheKey] = api;
      delete recInflight[cacheKey];
      return api || { html: '', intent: '' };
    }, function () {
      delete recInflight[cacheKey];
      return { html: '', intent: '' };
    });
    recInflight[cacheKey] = job;
    return job;
  }

  function paintRecs(el, api, fallback) {
    var track = el.querySelector('[data-cart-recs-track]');
    if (!track) return;
    var staging = document.createElement('ul');
    if (api && api.html) staging.innerHTML = api.html;
    dropInCartCards(staging, el.getAttribute('data-cart-sig'));
    var kept = fillRecTrack(staging, fallback);
    if (kept < 1) {
      el.hidden = true;
      return;
    }
    if (track.innerHTML !== staging.innerHTML) track.innerHTML = staging.innerHTML;
    el.setAttribute('data-recs-intent', (api && api.intent) ? api.intent : 'collection');
    el.hidden = false;
    bindRecArrows(el);
  }

  function syncOneRec(el) {
    var track = el.querySelector('[data-cart-recs-track]');
    var prev = el.querySelector('[data-cart-recs-prev]');
    var next = el.querySelector('[data-cart-recs-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    var overflow = max > 4;
    var atStart = track.scrollLeft <= 4;
    var atEnd = track.scrollLeft >= max - 4;
    prev.hidden = !overflow || atStart;
    next.hidden = !overflow || atEnd;
    prev.disabled = !!prev.hidden;
    next.disabled = !!next.hidden;
  }

  function syncCartRecArrows(root) {
    var scope = root || document;
    scope.querySelectorAll('cart-recs').forEach(function (el) { syncOneRec(el); });
  }

  function bindRecArrows(el) {
    if (!el) return;
    if (el._recsArrows) {
      syncOneRec(el);
      return;
    }
    var track = el.querySelector('[data-cart-recs-track]');
    var prev = el.querySelector('[data-cart-recs-prev]');
    var next = el.querySelector('[data-cart-recs-next]');
    if (!track || !prev || !next) return;
    el._recsArrows = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function step() {
      var first = track.querySelector('.cart-rec');
      if (!first) return track.clientWidth || 0;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap);
      if (isNaN(gap)) gap = parseFloat(styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function behavior() { return reduce.matches ? 'auto' : 'smooth'; }
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: behavior() });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: behavior() });
    });
    track.addEventListener('scroll', function () { syncOneRec(el); }, { passive: true });
    // Cart refresh replaces this element. Name the listener so disconnect
    // removes it. A new cart-recs adds one listener, not another stack.
    function onRecResize() { syncOneRec(el); }
    if (el._recsOnResize) window.removeEventListener('resize', el._recsOnResize);
    el._recsOnResize = onRecResize;
    window.addEventListener('resize', onRecResize, { passive: true });
    if (window.ResizeObserver) {
      if (el._recsObserver) el._recsObserver.disconnect();
      var ro = new ResizeObserver(function () { syncOneRec(el); });
      ro.observe(track);
      el._recsObserver = ro;
    }
    syncOneRec(el);
  }

  class CartRecs extends HTMLElement {
    connectedCallback() {
      bindRecArrows(this);
      if (this.getAttribute('data-cart-recs-mode') !== 'api') return;
      if (this._started) return;
      this._started = true;
      var self = this;
      var productId = this.getAttribute('data-product-id');
      var sig = this.getAttribute('data-cart-sig') || '';
      var cacheKey = recCacheKey(productId, sig);
      var base = this.getAttribute('data-recs-url');
      var liveFallback = this.querySelector('[data-cart-recs-fallback]');
      // Copy before any await. A drawer section refresh removes this node.
      var fallback = null;
      if (liveFallback) {
        fallback = document.createElement('ul');
        fallback.innerHTML = liveFallback.innerHTML;
      }
      if (!productId || !base) {
        paintRecs(self, { html: '', intent: '' }, fallback);
        return;
      }
      if (recCache[cacheKey]) {
        paintRecs(self, recCache[cacheKey], fallback);
        return;
      }
      loadRecApi(base, productId, cacheKey).then(function (api) {
        if (!self.isConnected) return;
        if (self.getAttribute('data-product-id') !== String(productId)) return;
        if ((self.getAttribute('data-cart-sig') || '') !== sig) return;
        paintRecs(self, api, fallback);
      });
    }

    disconnectedCallback() {
      if (this._recsOnResize) {
        window.removeEventListener('resize', this._recsOnResize);
        this._recsOnResize = null;
      }
      if (this._recsObserver) {
        this._recsObserver.disconnect();
        this._recsObserver = null;
      }
      this._recsArrows = false;
    }
  }

  if (!customElements.get('cart-recs')) customElements.define('cart-recs', CartRecs);

  /* Phone hide is html[data-cart-open], which must match a visible open sheet.
     iOS can restore a page from the back-forward cache, or return from the
     app switcher, with the hide still on after the sheet has closed. Clear
     it unless the drawer is actually open. A stuck is-open class on a sheet
     that is hidden must not keep the hub off screen. Page scroll lock
     (html.cart-drawer-open) is the same rule. Clearing the DOM lock without
     clearing _pageLocked made the next open() skip lockPage, so recovery
     goes through unlockPage and matches a real close.

     Body overflow is the shared page scroll lock. Quick view, the mobile
     menu, search, and the filter drawer each set it in their own open().
     pageshow and visibilitychange run even when the cart sheet is closed,
     so a blanket reset drops a lock those overlays still hold (Quick View
     stays open across a back-forward cache restore). Sticky add-to-cart
     and the bulk bar lock the bar itself with inert and aria-hidden. They
     do not set body overflow, and this reset does not remove those
     attributes. */
  function otherOverlayHoldsScrollLock() {
    if (document.querySelector('.quick-view-modal.is-open')) return true;
    // Header toggles, not the fading panel. Both opens set aria-expanded in
    // the same turn as the scroll lock, before is-open. Menu close, abort,
    // and releasePageLock, and search close, clear it before the panel
    // finishes hiding. A panel that is still shown is not an open sheet.
    if (document.querySelector('[data-menu-drawer-toggle][aria-expanded="true"]')) return true;
    if (document.querySelector('[data-search-drawer-toggle][aria-expanded="true"]')) return true;
    if (document.querySelector('facet-filters.is-open')) return true;
    if (document.body.classList.contains('filters-open')) return true;
    if (document.documentElement.getAttribute('data-filters-open') === 'true') return true;
    return false;
  }

  function releaseHubIfDrawerClosed() {
    var drawer = document.querySelector('cart-drawer');
    var sheet = drawer && drawer.querySelector('.cart-drawer');
    // is-open lands on the next frame. A pending _openFrame is already open:
    // auto-open and this release run in the same turn. close() cancels
    // _openFrame, so a real close still releases.
    var open = drawer && sheet && !sheet.hidden && (drawer.classList.contains('is-open') || !!drawer._openFrame);
    if (open) return;
    // Snapshot before unlockPage. When the cart still has _pageLocked,
    // unlockPage writes body overflow from this same check.
    var keepScrollLock = otherOverlayHoldsScrollLock();
    if (drawer && typeof drawer.unlockPage === 'function') drawer.unlockPage();
    var top = document.body.style.top;
    document.body.classList.remove('has-cart-drawer');
    document.documentElement.removeAttribute('data-cart-open');
    document.documentElement.classList.remove('cart-drawer-open');
    document.documentElement.style.overflow = '';
    // Same value unlockPage writes when the cart still had _pageLocked.
    // When it did not, unlockPage returns without touching overflow, so
    // this write is what keeps or clears the shared lock. The cart's html
    // overflow and position pin are still released.
    document.body.style.overflow = keepScrollLock ? 'hidden' : '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    var header = document.querySelector('.site-header');
    if (header) {
      header.style.position = '';
      header.style.top = '';
      header.style.left = '';
      header.style.right = '';
      header.style.width = '';
    }
    document.documentElement.style.setProperty('--cart-drawer-offset', '0px');
    if (top && parseInt(top, 10) < 0) {
      var y = -parseInt(top, 10);
      var root = document.documentElement;
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      if (document.scrollingElement) document.scrollingElement.scrollTop = y;
      window.scrollTo(0, y);
      root.style.scrollBehavior = prev;
    }
  }
  /* pageshow is fired on window and does not bubble. A document listener
     never runs on Safari back-forward cache restore, so a hide flag from
     the frozen page would stay set. Listen on both. */
  window.addEventListener('pageshow', releaseHubIfDrawerClosed);
  document.addEventListener('pageshow', releaseHubIfDrawerClosed);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') releaseHubIfDrawerClosed();
  });
  if (document.readyState !== 'loading') releaseHubIfDrawerClosed();
  else document.addEventListener('DOMContentLoaded', releaseHubIfDrawerClosed);
})();
